import { from } from 'rxjs'

import { AuthAPI } from 'api'
import { rxCheckStatus, rxPluckData, rxRetryWithBackoff } from 'utils/api'

export const api = {
  regenerateCode() {
    return from(AuthAPI.post('/authenticate/code/regenerate')).pipe(
      rxCheckStatus(),
      rxRetryWithBackoff(),
      rxPluckData()
    )
  },
}
